module.exports = __webpack_public_path__ + "img/map6.52653286.png";